import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import UiSelect from "../../../_uiComponents/common/form/UiSelectDefault";
import UiDatePicker from "../../../_uiComponents/common/UiDatePicker";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
     Chart,
     ChartTitle,
     ChartLegend,
     ChartArea,
     ChartTooltip,
     ChartSeries,
     ChartSeriesItem,
     ChartSeriesLabels,
} from "@progress/kendo-react-charts";
import UiSlider from "../../../_uiComponents/common/UiSlider";
import { showCustomLoading, timeFormatUtcToLocal } from "../../../../_helpers/support.services";
import { InnerLoader, PageLoader } from "../../../_uiComponents/common/UiLoadingSpinner";
import { dashboardConstants } from "../../../../_redux/_constants";

export default function DoughnutQ4WearTear(props) {
     const [startDate, setStartDate] = useState(null);
     const [jobRoleId, setJobRoleId] = useState("");

     const { dashboardQ4WearTearSummary, loader } = useSelector((state) => {
          return {
               dashboardQ4WearTearSummary:
                    state.dashboard.dashboardQ4WearTearSummary,
                    loader: state.loading,
          };
     });

     const getData = (startDate = null, jobRoleId = null) => {
          props.getWearTearSummary(
               startDate,

               jobRoleId,
               props.applicationId,
          );
     };

     useEffect(
          function () {
               getData(startDate, startDate, jobRoleId);
          },
          [props.applicationId],
     );

     const labelContent = e => `${e.category}: \n ${e.value}`;
     
     const donutCenterRenderer = () => (
          dashboardQ4WearTearSummary?.chartData.map((item) => (
               item.labelName == "Average National Performance" &&
               <>
                    <div className="sba-national-performance">
                         <h5>{item.labelName}</h5>
                         <h4>{item.ammount}</h4>
                    </div>
               </>
          ))
     );

     return (
          <>
          
          <div>
               <div className="sba-campaign-carousel-card">
               {showCustomLoading(
                    [dashboardConstants.DASHBOARD_GET_WEAR_TEER_SUMMARY_REQUEST],
                    loader.pendingRequests
               ) && <InnerLoader/>}     
                    <div className="sba-campaign-carousel-card__top">
                         <h3>Q4 Wear & Tear</h3>
                    </div>
                    <div className="sba-campaign-carousel-card__content">
                         <Chart donutCenterRender={
                              donutCenterRenderer
                         }>
                              <ChartSeries>
                                   <ChartSeriesItem
                                        type="donut"
                                        data={dashboardQ4WearTearSummary?.chartData
                                             .filter(item => item.labelName !== "Average National Performance")
                                             .map(function (item) {
                                                  return {
                                                       category: item.labelName,
                                                       amount: item.ammount,
                                                  };
                                             },
                                        )}
                                        categoryField="category"
                                        field="amount"
                                        align="column"
                                   >
                                        <ChartSeriesLabels
                                             position="outsideEnd"
                                             background="none"
                                             content={labelContent}
                                        />
                                   </ChartSeriesItem>
                              </ChartSeries>
                              <ChartLegend visible={false} position="bottom" />
                         </Chart>
                    </div>
               </div>
          </div>
          </>
     );
}
